import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  HOLD_DAILY_NOTE_FROM_BILLING_REQUEST,
  HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS,
  HOLD_DAILY_NOTE_FROM_BILLING_FAILURE,
  HOLD_DAILY_NOTE_FROM_BILLING_LOADING,
} = documentationActions;

function* holdDailyNoteFromBilling(action: any): SagaReturnType<any> {
  try {
    yield put({ type: HOLD_DAILY_NOTE_FROM_BILLING_LOADING });
    const response = yield call(dailySessionNotesService.holdFromBilling, action.payload);
    if (response?.status === 200) {
      yield put({
        type: HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS,
        payload: {
          response: response.data,
          dailySessionNoteUuid: action.payload?.dailySessionNoteUuid,
          hold: action.payload?.hold,
        },
      });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: HOLD_DAILY_NOTE_FROM_BILLING_FAILURE, payload: error });
  }
}

function* holdDailyNoteFromBillingSaga() {
  yield takeEvery(HOLD_DAILY_NOTE_FROM_BILLING_REQUEST, holdDailyNoteFromBilling);
}

export default holdDailyNoteFromBillingSaga;
